import cn from "classnames";
import { MouseEvent } from "react";
import { FileItemProps } from "../../types";
import { FileItemContext } from "./providers";
import { FileDelete, FileInfo, StatusIcon } from "./components";
import { useFileItemA11y } from "./hooks";
import styles from "./styles.module.scss";

export const FileItem = ({
  file,
  index,
  dataTestId,
  a11yChildCurrentIndex,
  a11yChildRefWithIndex,
  onFileDelete,
  onFileDownload,
  children,
}: FileItemProps) => {
  const errors = "errors" in file ? file.errors : undefined;
  const hasError = Boolean(errors);

  const handleFileDelete = (event: MouseEvent) => {
    onFileDelete(event, file.id);
  };

  const handleFileDownload = (event: MouseEvent) => {
    onFileDownload(event, file.id);
  };

  const { downloadButtonIndex, removeButtonIndex } = useFileItemA11y({ index });

  const defaultLayout = (
    <>
      <StatusIcon />
      <FileInfo />
      <FileDelete />
    </>
  );

  const hasChildren = children !== undefined && children !== null;

  const fileItemContent = hasChildren ? children : defaultLayout;

  return (
    <div
      className={cn(styles["file-item-container"], {
        [styles["with-children"]]: hasChildren,
      })}
      data-test-id={dataTestId}
    >
      <FileItemContext.Provider
        value={{
          a11yChildCurrentIndex,
          downloadButtonIndex,
          handleFileDownload,
          a11yChildRefWithIndex,
          file,
          hasError,
          dataTestId,
          removeButtonIndex,
          handleFileDelete,
          hasChildren,
        }}
      >
        {fileItemContent}
      </FileItemContext.Provider>
    </div>
  );
};

FileItem.FileDelete = FileDelete;
FileItem.FileInfo = FileInfo;
FileItem.StatusIcon = StatusIcon;
